import React, { useState, useEffect } from 'react';
import Comm from '../comm/comm';
import DivisionData from '../controls/divisionData';
import DivisionTree from '../controls/divisionTree';
import ModalInput from '../controls/ModalInput';
import Tools from '../tools/tools';




const Division = (props) => {
    let [sel, setSel] = useState();
    let [divisions, setDivisions] = useState([]);
    let [showAddMain, setShowAddMain] = useState(false);
    let [showAddSub, setShowAddSub] = useState(false);
    let [users, setUsers] = useState([])
    const loadData = () => {
        Comm.Instance().get(`division`).then(result => {

            setDivisions(JSON.parse(result.data));

        }).catch(error => Tools.ProcessError(error))
    }


    useEffect(() => {
        loadData();
        Comm.Instance().get(`user`).then(result => {
            setUsers(result.data);

        }).catch(error => Tools.ProcessError(error))
    }, []);

    const saveMain = (x) => {

        if (x) {
            Comm.Instance().post(`division`,
                {
                    Title: x,
                    Users: []
                })
                .then(result => {
                    setSel({
                        DivisionId: result.data,
                        Title: x,
                        Users: []
                    });
                    loadData();

                }).catch(error => Tools.ProcessError(error))
        }
        setShowAddMain(false);
    }


    const saveSub = (x) => {

        if (x) {
            Comm.Instance().post(`division`,
                {
                    Title: x,
                    ParentDivisionId: sel.DivisionId,
                    Users: []
                })
                .then(result => {
                    setSel({
                        DivisionId: result.data,
                        Title: x,
                        Users: []
                    });
                    loadData();

                }).catch(error => Tools.ProcessError(error))
        }
        setShowAddSub(false);
    }

    const save = (data) => {
        Comm.Instance().post(`division`, data)
            .then(result => {
                setSel(null);
                loadData();

            }).catch(error => Tools.ProcessError(error))
    }

    const del = () => {
        Comm.Instance().delete(`division/${sel.DivisionId}`)
            .then(result => {
                setSel(null);
                loadData();

            }).catch(error => Tools.ProcessError(error))
    }


    return (
        <div className="container">
            <h2>Дирекции</h2>
            <div className="form-row">
                <div className="form-group col-md-6" style={{ 'maxHeight': '60vh', 'overflowY': 'scroll' }}>
                    <DivisionTree divisions={divisions} sel={sel} setSel={setSel} />
                </div>
                <div className="form-group col-md-6">
                    <DivisionData sel={sel} save={save} users={users} />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-md-2">
                    <button className="btn btn-primary" onClick={() => setShowAddMain(true)}>Добави основен</button>
                    <ModalInput display={showAddMain} closeFunc={() => saveMain()} saveFunc={(x) => saveMain(x)} value={""} dataType="text" title="Нов основен елемент" />

                </div>
                <div className="form-group col-md-2">
                    {sel && <button className="btn btn-primary" onClick={() => setShowAddSub(true)}>Добави подчинен</button>}
                    <ModalInput display={showAddSub} closeFunc={() => saveSub()} saveFunc={(x) => saveSub(x)} value={""} dataType="text" title="Нов подчинен елемент" />
                </div>
                <div className="form-group col-md-2">
                    {sel && <button className="btn btn-danger" onClick={del}>Изтрий</button>}
                </div>
            </div>
        </div>
    );


}


export default Division;

